module.exports = __webpack_public_path__ + "assets/img/w_d_i_13.319229a0.jpg";